import React from 'react';
import * as PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

const StudyInfo = (props) => {
    const { studyBasicInfo } = props;
    const { t } = useTranslation();

    return (
        <>
            <Typography align="center" variant="body2" gutterBottom>
                <Trans t={t} i18nKey="pdash:login_and_register_you_are_joining" />
            </Typography>
            <Typography align="center" variant="subtitle2" gutterBottom>
                {studyBasicInfo.name}
            </Typography>
            <br />
            <Typography align="center" variant="body2" gutterBottom>
                <Trans t={t} i18nKey="pdash:login_and_register_organized_by" />
            </Typography>
            <Typography align="center" variant="subtitle2" gutterBottom>
                {studyBasicInfo.orgName}
            </Typography>
            <br />
            <Typography align="center" variant="body2" gutterBottom>
                <Trans
                    t={t}
                    i18nKey="pdash:web_app_login_and_register_please_create_account"
                    values={[process.env.REACT_APP_PAGE_TITLE_BASE || 'Avicenna']}
                />
            </Typography>
        </>
    );
};

StudyInfo.defaultProps = {
    studyBasicInfo: {},
};

StudyInfo.propTypes = {
    studyBasicInfo: PropTypes.shape({
        name: PropTypes.string,
        orgName: PropTypes.string,
    }),
};

export default StudyInfo;
